import { z } from 'zod';

export const PRESENTATION_TEMPLATE_MAX_BYTES = 20 * 1024 * 1024;
export const PRESENTATION_TEMPLATE_MIME =
  'application/vnd.openxmlformats-officedocument.presentationml.presentation';
export const presentationTemplateSchema = z
  .object({
    version: z.literal(1),
    id: z.uuid(),
    enabled: z.boolean(),
    name: z.string().min(1).max(200),
    sha256: z.string().regex(/^[a-f0-9]{64}$/),
    slide_count: z.number().int().min(1).max(100)
  })
  .strict();
export type PresentationTemplate = z.infer<typeof presentationTemplateSchema>;
export function parsePresentationTemplate(value: unknown) {
  const parsed = presentationTemplateSchema.safeParse(value);
  return parsed.success ? parsed.data : undefined;
}
export function presentationTemplateFilePath(id: string) {
  return `presentation-templates/${z.uuid().parse(id)}.pptx`;
}
